"use strict";

export function initInScope($scope) {
    $scope.find('.js-hide-on-touch').on('touchmove', function() {
        $(this).attr('hidden', 'hidden');
    })
}
